module.exports = __webpack_public_path__ + "static/media/CaretDown.bb19924a.svg";